import { useRef } from 'react'
import type ReactECharts from 'echarts-for-react'
import { useSocialHazardData } from '../../../hooks/useSocialHazardData'
import SocialHazardChart from '../../../chart/SocialHazardChart'
import { RiskProfileCard } from '../../RiskProfileCard'
import { ChartQueryState } from '../../ChartQueryState'
import { ChartExportActions } from '../../../chart/ChartExportActions'
import { useExportXlsx } from '../../../hooks/useExportXlsx'
import { useExportChartImage } from '../../../hooks/useExportChartImage'
import type {
  PropertiesQueryParams,
  PropertiesMetricOption,
} from '../../../types/riskProfileProperties.types'

export interface SocialHazardsWidgetProps {
  queryParams: PropertiesQueryParams | null
  metricOption: PropertiesMetricOption
}

export function SocialHazardsWidget({ queryParams, metricOption }: SocialHazardsWidgetProps) {
  const { request, query } = useSocialHazardData(queryParams)
  const { exportXlsx, isExporting } = useExportXlsx(request, '/report/risk-profile/properties/xlsx')
  const chartRef = useRef<ReactECharts>(null)
  const handleExportImage = useExportChartImage(chartRef, 'residents-exposed-by-hazard')

  return (
    <RiskProfileCard
      title="Number of residents exposed by hazard type"
      description="Number of residents exposed by hazard type."
      onExport={
        <ChartExportActions
          onExportXlsx={exportXlsx}
          onExportImage={handleExportImage}
          isExportingXlsx={isExporting}
          xlsxDisabled={!request}
        />
      }
      className="min-h-96"
    >
      <ChartQueryState query={query}>
        {(data) => (
          <SocialHazardChart
            ref={chartRef}
            data={data}
            metricOption={metricOption}
            entityNoun="residents"
          />
        )}
      </ChartQueryState>
    </RiskProfileCard>
  )
}
